import React, { useEffect, useRef } from 'react';

export default function Popover({ open, onClose, align = 'start', className = '', children }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleMouseDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose?.();
    };
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  const alignCls = align === 'end' ? 'right-0' : 'left-0';

  return (
    <div
      ref={ref}
      className={`absolute z-50 mt-2 ${alignCls} rounded-xl border border-border-default bg-elevated shadow-lg shadow-black/5 dark:shadow-black/40 ${className}`}
    >
      {children}
    </div>
  );
}
